<template>
  <v-dialog width="800" v-model="dialog">
    <template v-slot:activator="{ on }">

      <slot name="activator" v-bind:data="{on: on}">
        <v-btn v-on="on" icon >
          <v-icon dark>edit</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-sheet>
      <div style="padding: 2rem">
        <v-select label="Team" v-model="selectedTeams"  multiple item-text="name" item-value="id" :items="teams"></v-select>
      </div>
      <v-btn style="z-index: 99999999" color="blue darken-1" flat @click="update()">Zapisz</v-btn>
    </v-sheet>

  </v-dialog>
</template>

<script>
import PdfViewer from "@/components/pdf/Viewer";
import Messenger from "../../plugins/Messenger";

export default {
  name: "EditFileTeams",
  components: {
    PdfViewer
  },
  props: ['fileId', 'teamIds'],
  data() {
    return {
      documentFile: {},
      selectedTeams:[],
      dialog: false,
      loading:false
    }
  },
  computed: {
    teams: {
      get: function () {
        return this.$store.getters.teams
      }
    },
    locale: () => process.env.VUE_APP_LOCALE
  },
  watch: {
    teamIds: function (newVal) {
      if (newVal) {
        this.selectedTeams = this.teamIds
      }
    }
  },
  methods: {
    update() {
      if (this.selectedTeams) {
        this.$http.patch('user-file/' + this.fileId + '/teams', this.selectedTeams).then(data=>{
          this.$emit('fileTeamUpdated', data.data)
          Messenger.emitSuccess("Team zaktualizowany")
          this.dialog = false
        }).catch(() =>{
          Messenger.emitError("Problem z aktualizacją")
        })
      }
    },
  },
}
</script>

<style scoped>
#btn_container {
  margin-bottom: -2rem;
}
</style>